import Message from "../../message";
import {useMainStore} from "@/store";

export default class SaleUpdated extends Message
{
    handle()
    {
        useMainStore().UPDATE_SALE(this.message.sale);
    }
}
